// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/","parentId":"@@/global-layout","id":"1"},"2":{"path":"/privacy","parentId":"@@/global-layout","id":"2"},"3":{"path":"/privacy/en","parentId":"@@/global-layout","id":"3"},"4":{"path":"/accoutDeletion","parentId":"@@/global-layout","id":"4"},"5":{"path":"/register","parentId":"@@/global-layout","id":"5"},"6":{"path":"/agreement","parentId":"@@/global-layout","id":"6"},"7":{"path":"/agreement/en","parentId":"@@/global-layout","id":"7"},"@@/global-layout":{"id":"@@/global-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import(/* webpackChunkName: "p__index" */'@/pages/index.tsx')),
'2': React.lazy(() => import(/* webpackChunkName: "p__privacy__index" */'@/pages/privacy/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__privacy__en" */'@/pages/privacy/en.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__logout__index" */'@/pages/logout/index.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__register__index" */'@/pages/register/index.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__agreement__index" */'@/pages/agreement/index.tsx')),
'7': React.lazy(() => import(/* webpackChunkName: "p__agreement__en" */'@/pages/agreement/en.tsx')),
'@@/global-layout': React.lazy(() => import(/* webpackChunkName: "layouts__index" */'/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/src/layouts/index.tsx')),
},
  };
}
